// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Details of an adjudication code
*/
export class ClaimLookupsAdjudicationCodeLookupModel {
    /**
    * @description Description
    */
    'description'?: string | null;
    /**
    * @description Code
    */
    'code'?: string | null;
    /**
    * @description ID
    */
    'id'?: number;
    /**
    * @description The paragraphs of the description as separate strings
    */
    'descriptionParagraphs'?: Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimLookupsAdjudicationCodeLookupModel>> = [
        {
            "name":     "description",
            "baseName": "description",
            "type":     "string"
        },
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "id",
            "baseName": "id",
            "type":     "number"
        },
        {
            "name":     "descriptionParagraphs",
            "baseName": "descriptionParagraphs",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimLookupsAdjudicationCodeLookupModel.attributeTypeMap;
    }
}
